// =====================================================================
//  Paquet template EASYMAIL — format d'échange « easymail-template/1 »
//  ---------------------------------------------------------------------
//  Format JSON (clés camelCase) échangé entre un agent IA et le
//  back-office. Spécification : docs/TEMPLATE_PACKAGE_FORMAT.md.
//  Volontairement DISTINCT d'ITemplateModel / IOtpStrategyModel : on ne
//  désérialise jamais un paquet directement en modèle, on passe par
//  PackageMapper.
// =====================================================================

export const PACKAGE_FORMAT = "easymail-template/1";
export const PACKAGE_MAX_BYTES = 1024 * 1024;
export const PACKAGE_FILE_EXTENSION = ".easymail.json";

export type PackageTypeContent = "html" | "text";
export type PackageTypeProcess = "mail" | "html" | "pdf";
export type PackageOtpAlphabet = "numeric" | "alphanumeric" | "alphanumericNoAmbiguous";
export type PackageOtpCase = "upper" | "lower" | "mixed";
export type PackageOtpChannel = "mail" | "sms";

export interface IPackageSource {
    /** Primarykey du pivot exporté. */
    templateId: string;
    /** Primarykey de la stratégie OTP exportée (export depuis l'éditeur OTP). */
    otpStrategyId?: string;
    environment?: string;
    exportedAt?: string;
}

export interface IPackageMeta {
    generator?: string;
    createdAt?: string;
    source?: IPackageSource;
}

export interface IPackageSender {
    email: string;
    name?: string;
}

export interface IPackageTemplate {
    name: string;
    label?: string;
    typeContent: PackageTypeContent;
    typeProcess?: PackageTypeProcess;
    subject: string;
    body: string;
    sender?: IPackageSender;
}

export interface IPackageTranslation {
    language: string;
    subject: string;
    body: string;
}

export interface IPackageOtpPattern {
    length: number;
    alphabet: PackageOtpAlphabet;
    case?: PackageOtpCase;
    groupSize?: number;
    groupSeparator?: string;
}

export interface IPackageOtpStrategy {
    name: string;
    label?: string;
    pattern: IPackageOtpPattern;
    expirationMinutes: number;
    maxAttempts: number;
    channels: Array<PackageOtpChannel>;
}

export interface IEasymailPackage {
    format: string;
    meta?: IPackageMeta;
    template: IPackageTemplate;
    modelTest: Record<string, unknown>;
    translations?: Array<IPackageTranslation>;
    otpStrategy?: IPackageOtpStrategy;
    notes?: string;
}

/** Variables injectées par EASYMAIL dans un template OTP (cf. docs/OTP.md § 5). */
export const OTP_RESERVED_VARIABLES = ["Code", "ExpiresAt"];
